import type {UpdateServiceFunctionFormPayload} from "./update-service-function.schema";

import {updateServiceFunction} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {serviceFunctionKeys, serviceFunctionMutationKeys} from "../../../serviceFunction-keys";

export function updateServiceFunctionMutationOptions(serviceFunctionId: string) {
  return mutationOptions({
    mutationFn: (payload: UpdateServiceFunctionFormPayload) =>
      updateServiceFunction(serviceFunctionId, payload),
    mutationKey: serviceFunctionMutationKeys.updateServiceFunction,
    onSuccess: async (_data, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: serviceFunctionKeys.detail(serviceFunctionId)}),
        client.invalidateQueries({queryKey: serviceFunctionKeys.lists()}),
      ]);
    },
  });
}
